import { DEFAULT_ERROR } from 'modules/errors/constants/index.js'
import { getObjectUtil } from 'packages/src'

function getMessageErrorUtil (error) {
  if (typeof error === 'string') {
    return error
  }
  return (
    getObjectUtil(error, 'error.message') ||
    getObjectUtil(error, 'message') ||
    DEFAULT_ERROR
  )
}

export default getMessageErrorUtil
